module.exports = __webpack_public_path__ + "img/vertical_7_4_6000.f61a3a35.png";